const UTILS = {
  OnElementLoad: (selector, callback) => {
    var t = setInterval(() => {
      var element = document.querySelector(selector);
      if (element !== null && element !== undefined) {
        clearInterval(t);
        callback(element);
      }
    }, 500);
  }
};

(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductMediaCarousel', () => ({
      $section: null,
      init() {
        let am = this;
        document.addEventListener('init-ProductMediaCarousel', (e) => {
          if (am.$section) return;

          am.$section = e.target;
          am.OnSlideChangeHandler();
        });
      },
      OnSlideChangeHandler() {
        let am = this;

        let $carousel = am.$section.querySelector('flickity-carousel');
        $carousel.addEventListener('flickity:slide-changed', (e) => {
          // console.log(e);
          let $currentSlide = am.$section.querySelector('.product__media-item.is-selected');
          let currentSlideMediaId = $currentSlide.dataset.mediaId;

          let $variantSwatch = document.querySelector(`.variant-swatch__radio[data-variant_media_id="${ currentSlideMediaId }"]`);
          if ($variantSwatch) {
            $variantSwatch.checked = true;
            $variantSwatch.dispatchEvent(new CustomEvent('change', {bubbles: true}));
          }
          else {
            // check for alt text
            let alt_text = $currentSlide.dataset.mediaAlt;
            if (!alt_text) return;

            let variant_name = alt_text.split('|')[1];
            if (!variant_name) return;

            $variantSwatch = document.querySelector(`.variant-swatch__radio[data-variant_name*="${ variant_name }"]`);
            if (!$variantSwatch) return;

            $variantSwatch.checked = true;
            window.preventImageChange = true;
            $variantSwatch.dispatchEvent(new CustomEvent('change', {bubbles: true}));
            setTimeout(() => {
              window.preventImageChange = false;
            }, 250);
          }
        });
      }
    }));

    Alpine.data('ProductFormButtons', () => ({
      mounted() {
        let am = this;
        UTILS.OnElementLoad('.klaviyo-bis-trigger', ($node) => {
          am.$el.insertAdjacentElement('afterbegin', $node);
        });
      }
    }));
  });
})();